import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setopen_modal, setorder_modal } from '../../slices/globalslice';
import ChangePasswordModal from './ChangePasswordModal';
import OrderModal from '../../pages/orders/OrderModal';
const CustomModal = () => {
    const open_modal = useSelector(state => state.globalslice.open_modal);
    const order_modal = useSelector(state => state.globalslice.order_modal);
    const dispatch = useDispatch()
    const closeModal = () => dispatch(setopen_modal(false));
    const closeorderModal = () => dispatch(setorder_modal(false));


    return (
        <Modal
            isOpen={open_modal}
            toggle={closeModal}
            size={order_modal ? "xl" : "md"}
            centered
        >
            <ModalBody className={order_modal ? "order-modal-main" : ""}>

                {
                    order_modal && open_modal ?
                        <OrderModal closeModal={closeModal} closeordermodal={closeorderModal} /> :
                        <ChangePasswordModal closeModal={closeModal} />
                }

            </ModalBody>
        </Modal>
    )
}

export default CustomModal
